import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Card, Container } from "react-bootstrap"
//import jwt_decode from "jwt-decode"

import { getSecurityQuestions, getSecuritySetupStatus } from "@api/authenticate"
import { useAuth } from "@src/context"
import { toast } from "@components/ToastExtended"
import SetupSecurityModal from "@components/SetupSecurityModal/SetupSecurityModal"
import { Header } from "@components/Header"

const SetupSecurity = () => {
    const navigate = useNavigate()
    const { setLoginStatus } = useAuth()
    const [setupStep, setSetupStep] = useState("questions")
    const [stepResolved, setStepResolved] = useState(false)

    useEffect(() => {
        if (!localStorage.getItem("Token") || localStorage.getItem("security_setup_required") !== "true") {
            navigate("/", { replace: true })
        }
    }, [navigate])

    useEffect(() => {
        getSecuritySetupStatus()
            .then((res) => {
                const { questions_configured, mfa_configured } = res?.data ?? {}
                if (questions_configured && !mfa_configured) {
                    setSetupStep("totp")
                }
            })
            .catch(() => {})
            .finally(() => setStepResolved(true))
    }, [])

    const [securityQuestionsList, setSecurityQuestionsList] = useState([])
    const [totpProvisioningUri, setTotpProvisioningUri] = useState(null)

    useEffect(() => {
        if (securityQuestionsList.length === 0) {
            getSecurityQuestions()
                .then((res) => setSecurityQuestionsList(res?.data ?? []))
                .catch(() => setSecurityQuestionsList([]))
        }
    }, [securityQuestionsList.length])

    // const navigateAfterLogin = (access) => {
    //     const redirectToPlans = localStorage.getItem("redirectToPlans")
    //     if (redirectToPlans) {
    //         const planType = redirectToPlans
    //         localStorage.removeItem("redirectToPlans")
    //         const decoded = jwt_decode(access)
    //         if (decoded.role === "candidate") {
    //             navigate("/candidate-pay-for-service", { replace: true })
    //         } else if (decoded.role === "employer") {
    //             navigate("/employer-pay-for-service", { replace: true })
    //         } else {
    //             if (planType === "candidates") {
    //                 navigate("/candidate-pay-for-service", { replace: true })
    //             } else {
    //                 navigate("/employer-pay-for-service", { replace: true })
    //             }
    //         }
    //     } else {
    //         navigate("/", { replace: true })
    //     }
    // }

    return (
        <>
            <Header />
            <div className="fixed-nav-margin">
                <Container className="my-5 py-5">
                    <Card className="shadow-lg mx-auto" style={{ maxWidth: "32rem" }}>
                        <Card.Body className="p-4">
                            <Card.Title className="mb-2">Complete your security setup</Card.Title>
                            <Card.Text className="text-muted small mb-4">
                                {setupStep === "totp"
                                    ? "Set up Authenticator to complete your security setup."
                                    : "You must set up security questions and Authenticator before you can use your account."}
                            </Card.Text>
                            {!stepResolved && (
                                <Card.Text className="text-muted small">Checking your setup...</Card.Text>
                            )}
                            <SetupSecurityModal
                                show={stepResolved}
                                setupToken={null}
                                setupStep={setupStep}
                                setSetupStep={setSetupStep}
                                securityQuestionsList={securityQuestionsList}
                                totpProvisioningUri={totpProvisioningUri}
                                setTotpProvisioningUri={setTotpProvisioningUri}
                                // onComplete={() => {
                                //     localStorage.removeItem("security_setup_required")
                                //     setTotpProvisioningUri(null)
                                //     toast.show({
                                //         type: "success",
                                //         title: "Security setup complete",
                                //     })
                                //     const access = localStorage.getItem("Token")
                                //     if (access) navigateAfterLogin(access)
                                //     else navigate("/", { replace: true })
                                // }}
                                onComplete={() => {
                                    // Setup is complete on the backend, and the activation email has been
                                    // sent. Force a logout so the user clearly understands their next step:
                                    // check the email, click the link, then sign in fresh.
                                    localStorage.removeItem("Token")
                                    localStorage.removeItem("RefreshToken")
                                    localStorage.removeItem("security_setup_required")
                                    setLoginStatus(false, null)
                                    setTotpProvisioningUri(null)

                                    toast.show({
                                        type: "success",
                                        title: "Setup complete!",
                                        description: "Please check your email and click the activation link, then sign in.",
                                    })

                                    //navigate("/sign-in", { replace: true })
                                    window.location.href = "/sign-in"
                                }}
                                onCancel={() => {
                                    // User chose to leave setup mid-flow. Clear auth state and redirect
                                    // to sign-in with a "your progress is saved" message. Their backend
                                    // state (security_setup_completed=false) means they can come back any
                                    // time and pick up where they left off via the login flow.
                                    localStorage.removeItem("Token")
                                    localStorage.removeItem("RefreshToken")
                                    localStorage.removeItem("security_setup_required")
                                    setLoginStatus(false, null)
                                    setTotpProvisioningUri(null)

                                    toast.show({
                                        type: "info",
                                        title: "Progress saved",
                                        description: "You can sign in any time to continue your security setup.",
                                    })

                                    window.location.href = "/sign-in"
                                }}
                            />
                        </Card.Body>
                    </Card>
                </Container>
            </div>
        </>
    )
}

export default SetupSecurity
